import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve image URLs that may be either absolute (https://…) or backend-relative ("/api/files/…").
 * Returns an empty string for falsy input.
 */
export const imgSrc = (url) => {
    if (!url) return "";
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
};

export const api = axios.create({
    baseURL: API,
    withCredentials: true, // send/receive the httpOnly session_token cookie
});

export default api;
